<template>
  <div id="mobile-col1-container">
    <TTReader :panel="SIDEBAR_TOP" />

    <GraphTableTotal v-if="showPiechartSidebar" />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import TTReader from '@/components/TipTap/wrappers/TTReader.vue'
import GraphTableTotal from '@/components/public/GraphTable/GraphTableTotal.vue'
import { StoryKeys } from '@/types'
import { APP_CONFIG_KEY } from '@/constants'

const components = {
  TTReader,
  GraphTableTotal,
}

@Component({ components })
export default class MobileCol1 extends Vue {
  SIDEBAR_TOP = StoryKeys.SIDEBAR_TOP

  get showPiechartSidebar () {
    return this.$typedStore.primary.app.config[APP_CONFIG_KEY].showPiechartSidebar
  }
}

</script>

<style>

#mobile-col1-container .graph-table-container .table {
  color: inherit;
}

</style>
